import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

export const Link = styled.a`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primaryBlue};
`;
